import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "tw-mb-6 tw-min-h-[570px] tw-overflow-auto table-parent-lan" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    colspan: "12",
    class: "text-center py-5 tw-text-[var(--foreground)]"
};
import { ref, computed, watch, onMounted, nextTick } from 'vue';
import axios from 'axios';
import { Table, TableRow, TableCell, TableBody, TableHead, TableHeader, } from '@/components/ui/table';
import TablePagination from '@/components/TablePagination.vue';
import { dateFormat } from '@/lib/dateFormat';
import Const from '@/const';
import { useI18n } from 'vue-i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Casino',
    setup(__props) {
        const { t } = useI18n();
        const isLoading = ref(true);
        const users = ref([]);
        const filters = ref({ search: '', currentPage: 1, itemsPerPage: 5 });
        const meta = ref({ total: 0, lastIndex: 0, firstIndex: 0 });
        const fetchUserData = async () => {
            const isLocalhost = window.location.hostname === 'localhost';
            let ApiUrl = 'http://localhost:8080/api/get_casino_history.json';
            try {
                if (!isLocalhost) {
                    ApiUrl = `${Const.URL}/sports/get_casino_history`;
                    const response = await axios.post(ApiUrl);
                    users.value = response.data;
                    meta.value.total = response.data.length;
                }
                else {
                    const response = await axios.get(ApiUrl);
                    users.value = response.data;
                    meta.value.total = response.data.length;
                }
                updatePagination();
            }
            catch (error) {
                console.error('Error fetching user data:', error);
            }
            finally {
                isLoading.value = false;
            }
        };
        const updatePagination = () => {
            const start = (filters.value.currentPage - 1) * filters.value.itemsPerPage;
            const end = start + filters.value.itemsPerPage;
            meta.value.firstIndex = start;
            meta.value.lastIndex = Math.min(end, meta.value.total);
            if (meta.value.total > 0) {
                meta.value.firstIndex += 1;
            }
        };
        const paginatedUsers = computed(() => {
            const start = (filters.value.currentPage - 1) * filters.value.itemsPerPage;
            const end = start + filters.value.itemsPerPage;
            return users.value.slice(start, end);
        });
        watch(() => filters.value.itemsPerPage, () => {
            updatePagination();
            nextTick(() => {
                console.log('Items per page updated: ', filters.value.itemsPerPage);
            });
        });
        // Watch for changes in currentPage and recalculate pagination
        watch(() => filters.value.currentPage, () => {
            updatePagination();
            nextTick(() => {
                console.log('Current page updated: ', filters.value.currentPage);
            });
        });
        onMounted(() => {
            fetchUserData();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Table), { class: "tw-w-full tw-min-w-[1240px] tw-overflow-auto tw-text-[var(--foreground)] tw-min-h-[366px]" }, {
                    default: _withCtx(() => [
                        _createVNode(_unref(TableHeader), null, {
                            default: _withCtx(() => [
                                _createVNode(_unref(TableRow), null, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_unref(t)('id'), _unref(t)('date'), _unref(t)('game'), _unref(t)('bet'), _unref(t)('win')], (head) => {
                                            return (_openBlock(), _createBlock(_unref(TableHead), {
                                                key: head,
                                                class: "!tw-py-5 !tw-px-5 tw-border tw-broder-b-[#515151] tw-border-x-0 tw-border-t-0 !tw-text-sm !tw-text-[var(--foreground)]"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(head), 1)
                                                ]),
                                                _: 2
                                            }, 1024));
                                        }), 128))
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(TableBody), null, {
                            default: _withCtx(() => [
                                (isLoading.value)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
                                        _createElementVNode("td", _hoisted_3, _toDisplayString(_unref(t)('loading')), 1)
                                    ]))
                                    : (!isLoading.value && paginatedUsers.value.length === 0)
                                        ? (_openBlock(), _createBlock(_unref(TableRow), {
                                            key: 1,
                                            class: "tw-py-10"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(TableCell), {
                                                    colspan: "12",
                                                    class: "tw-text-center tw-py-24 tw-text-[var(--foreground)]"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(t)('noDataFound')), 1)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedUsers.value, (user) => {
                                    return (_openBlock(), _createBlock(_unref(TableRow), {
                                        key: user.id
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(TableCell), { class: "!tw-p-5 !tw-border tw-border-b-[#374151] !tw-border-x-0 !tw-border-t-0 tw-text-[var(--foreground)]" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(user.id), 1)
                                                ]),
                                                _: 2
                                            }, 1024),
                                            _createVNode(_unref(TableCell), { class: "!tw-p-5 !tw-border tw-border-b-[#374151] !tw-border-x-0 !tw-border-t-0 tw-text-[var(--foreground)]" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(dateFormat)(user.date_time, 'DD MMM YYYY')), 1)
                                                ]),
                                                _: 2
                                            }, 1024),
                                            _createVNode(_unref(TableCell), { class: "!tw-p-5 !tw-border tw-border-b-[#374151] !tw-border-x-0 !tw-border-t-0 tw-text-[var(--foreground)]" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(user.game), 1)
                                                ]),
                                                _: 2
                                            }, 1024),
                                            _createVNode(_unref(TableCell), { class: "!tw-p-5 !tw-border tw-border-b-[#374151] !tw-border-x-0 !tw-border-t-0 tw-text-[var(--foreground)]" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(user.bet), 1)
                                                ]),
                                                _: 2
                                            }, 1024),
                                            _createVNode(_unref(TableCell), { class: "!tw-p-5 !tw-border tw-border-b-[#374151] !tw-border-x-0 !tw-border-t-0 tw-text-[var(--foreground)]" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(user.win), 1)
                                                ]),
                                                _: 2
                                            }, 1024)
                                        ]),
                                        _: 2
                                    }, 1024));
                                }), 128))
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                _createVNode(TablePagination, {
                    class: "!tw-font-normal tw-py-0 tw-my-4 tw-mx-0 tw-text-[#738499]",
                    modelValue: filters.value.currentPage,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filters.value.currentPage) = $event)),
                    total: meta.value.total,
                    lastIndex: meta.value.lastIndex,
                    firstIndex: meta.value.firstIndex,
                    "items-per-page": filters.value.itemsPerPage
                }, null, 8, ["modelValue", "total", "lastIndex", "firstIndex", "items-per-page"])
            ]));
        };
    }
});
